import { RoomTypes } from '~analytics/types';
import { ReportAnalytics } from '~teacher/components/QuizResultsHeader/ReportAnalyticsContext';

import { sendGenerateReportEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class GenerateReportEmailStudentsEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendGenerateReportEvent;

  constructor(props: {
    include_correct_answers: boolean;
    include_explanations: boolean;
    recipient_count: number;
    analytics: ReportAnalytics;
  }) {
    super();

    try {
      this.eventData = {
        report_type: 'individual_students',
        delivery_method: 'email_to_students',
        option_include_explanations: props.include_explanations,
        option_include_correct_answers: props.include_correct_answers,
        email_to_students_recipient_count: props.recipient_count,
        activity_student_count: props.analytics.studentCount,
        activity_question_count: props.analytics.questionCount,
        activity_type: props.analytics.activity.activityType,
        activity_room_type: props.analytics.activity.isRostered
          ? RoomTypes.RosteredRoom
          : RoomTypes.OpenRoom,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
